import { z } from 'zod';

const senhaRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/;

export const tipoPerfilEnum = z.enum([
  'EMPRESARIO',
  'EXECUTIVO',
  'PROFISSIONAL',
  'CONSULTOR',
  'INVESTIDOR',
  'MENTOR',
]);

export const faturamentoEnum = z.enum([
  'ATE_500K',
  'ENTRE_500K_2M',
  'ENTRE_2M_10M',
  'ENTRE_10M_50M',
  'ACIMA_50M',
]);

export const frequenciaEnum = z.enum(['BAIXA', 'MEDIA', 'ALTA']);

export const diagnosticoFaseEnum = z.enum([
  'IDEACAO',
  'VALIDACAO',
  'CRESCIMENTO',
  'EXPANSAO',
  'MATURIDADE',
]);

export const signupSchema = z.object({
  nome: z.string().trim().min(3, 'Nome deve ter ao menos 3 caracteres'),
  email: z.string().trim().email('Email inválido'),
  senha: z
    .string()
    .min(8, 'Mínimo 8 caracteres')
    .regex(senhaRegex, 'Use ao menos 1 maiúscula, 1 número e 1 caractere especial'),
  tipoPerfil: tipoPerfilEnum,
  cargo: z.string().trim().min(2, 'Informe seu cargo'),
  empresa: z.string().trim().min(2, 'Informe sua empresa'),
  segmento: z.string().trim().min(2, 'Informe seu segmento'),
  estado: z
    .string()
    .trim()
    .length(2, 'UF com 2 letras')
    .regex(/^[A-Z]{2}$/, 'Use letras maiúsculas'),
  faturamento: faturamentoEnum,
  tamanhoTime: z.coerce
    .number({ invalid_type_error: 'Informe um número' })
    .int('Use número inteiro')
    .min(1, 'Mínimo 1 pessoa')
    .max(100_000, 'Máximo 100.000'),
  frequenciaNetworking: frequenciaEnum,
  tagsBuscaIds: z.array(z.string()).min(1, 'Selecione ao menos 1').max(3, 'Máximo 3'),
  tagsOfertaIds: z.array(z.string()).min(1, 'Selecione ao menos 1').max(3, 'Máximo 3'),
  gargalo: z
    .string()
    .trim()
    .min(10, 'Descreva com pelo menos 10 caracteres')
    .max(500, 'Máximo 500 caracteres'),
  diagnosticoFase: diagnosticoFaseEnum,
  consentSponsor: z.boolean(),
});

export type SignupFormValues = z.infer<typeof signupSchema>;
export type SignupFieldName = keyof SignupFormValues;
